import * as Yup from 'yup'

const phoneFormSchema = Yup.object({
  phone: Yup.number().required('Debes especificar tu número de teléfono'),
})

export default phoneFormSchema
